export const getCardNumber = (numberSrc?: string) => {
    if(!(numberSrc?.length && typeof(numberSrc) === 'string') ) {
        return ''
    }
    const reg = new RegExp('^[^0-9]{2,}')
    const lettersStarts = numberSrc.match(reg)
    if(lettersStarts?.length){
        const prefixNumber = numberSrc.startsWith('№') ? '' : '№ '
        return prefixNumber + numberSrc.slice(0,2) + ' ' + numberSrc.slice(2)
    }
    return numberSrc
}export const getCardNumber = (numberSrc?: string) => {
    if(!(numberSrc?.length && typeof(numberSrc) === 'string') ) {
        return ''
    }
    const reg = new RegExp('^[^0-9]{2,}')
    const lettersStarts = numberSrc.match(reg)
    if(lettersStarts?.length){
        const prefixNumber = numberSrc.startsWith('№') ? '' : '№ '
        return prefixNumber + numberSrc.slice(0,2) + ' ' + numberSrc.slice(2)
    }
    return numberSrc
}